import { render, staticRenderFns } from "./InboxBadge.vue?vue&type=template&id=84e39cea&"
import script from "./InboxBadge.vue?vue&type=script&lang=js&"
export * from "./InboxBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports